import { ReactElement } from 'react';
import Content from './Content';
import {
  LoginContainer,
  LoginCard,
  FullWidthSpace,
  ServiceName,
  MicrophoneIcon,
  ServiceSubtitle,
  TitleContainer,
} from './styles';
import Title from 'antd/es/typography/Title';
import { Mic } from 'lucide-react';

const LoginPage = (): ReactElement => {
  return (
    <LoginContainer>
      <TitleContainer>
        <MicrophoneIcon>
          <Mic size={45} color='currentColor' strokeWidth={2.5} />
        </MicrophoneIcon>
        <ServiceName>AI議事録チェッカー</ServiceName>
        <ServiceSubtitle>会議録音管理システム</ServiceSubtitle>
      </TitleContainer>
      <LoginCard>
        <FullWidthSpace direction='vertical' size='large'>
          <Title level={1}>ログイン</Title>
          <Content />
        </FullWidthSpace>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
